// extracted by mini-css-extract-plugin
export default {"contactBox":"vwLggQ7ossUPKEqBvMXX-ContactBox-contactBox"};